export default __webpack_public_path__ + "static/media/js.dd493364.png";